// Radha — Dutch (nl-NL) locale pack.
// Shell chrome only: nav, header, repeated states and actions. Panel body
// copy is intentionally absent — it is finance/legal terminology that needs
// native review, and t() falls back to English until it is translated.
const nl = {
  "nav.overview": "Overzicht",
  "nav.collections": "Incasso",
  "nav.disputes": "Geschillen",
  "nav.contracts": "Contracten",
  "nav.invoicing": "Facturatie",
  "nav.recurring": "Terugkerend",
  "nav.statements": "Rekeningoverzichten",
  "nav.creditNotes": "Creditnota's",
  "nav.gst": "Btw",
  "nav.tax": "Btw & e-facturatie",
  "nav.reconciliation": "Reconciliatie",
  "nav.deductions": "Deducties",
  "nav.withholding": "Bronbelasting",
  "nav.cashflow": "Kasstroom",
  "nav.crm": "CRM",
  "nav.forecasts": "Prognoses",
  "nav.reminders": "Herinneringen",
  "nav.dunning": "Aanmaning",
  "nav.automation": "Automatisering",
  "nav.settings": "Instellingen",
  "nav.privacy": "Privacy",
  "group.receivables": "Debiteuren",
  "group.planning": "Planning",
  "group.operations": "Operatie",
  "group.admin": "Beheer",
  "app.tagline": "Revenue Operating System",
  "app.signOut": "Afmelden",
  "app.search": "Zoeken",
  "app.toggleTheme": "Kleurthema wisselen",
  "app.toggleNav": "Navigatie tonen",
  "app.language": "Taal",
  "app.useTenantDefault": "Standaard van tenant gebruiken",
  "state.loading": "Laden…",
  "state.error": "Kan gegevens niet laden",
  "state.empty": "Nog niets",
  "state.readOnly": "Alleen-lezen",
  "action.approve": "Goedkeuren",
  "action.reject": "Afwijzen",
  "action.save": "Opslaan",
  "action.saving": "Opslaan…",
  "action.saved": "Opgeslagen",
  "action.cancel": "Annuleren",
  "action.export": "Exporteren naar Excel",
};
export default nl;
